import _asyncToGenerator from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { EvUserPreferencesApi } from "../../apiclient/api/EvUserPreferencesApi";
var userPreferences = new EvUserPreferencesApi();
export var updateSessionSettings = createAsyncThunk("SessionSettings/update", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(sessionInfo) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", userPreferences.updateUserSession(sessionInfo));
          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
export var initializeSessionSettings = createAsyncThunk("SessionSettings/initialize", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", payload);
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}());
var initialState = {
  sessionSettings: {
    data: undefined,
    status: "init",
    initializeStatus: "init"
  }
};
var sessionSettingsSlice = createSlice({
  name: "sessionSettings",
  initialState: initialState,
  reducers: {
    // omit reducer cases
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(updateSessionSettings.pending, function (state) {
      state.sessionSettings.status = "pending";
    }).addCase(updateSessionSettings.fulfilled, function (state, _ref3) {
      var payload = _ref3.payload;
      state.sessionSettings.status = "done";
      state.sessionSettings.data = payload;
    }).addCase(updateSessionSettings.rejected, function (state) {
      state.sessionSettings.status = "error";
    }).addCase(initializeSessionSettings.pending, function (state) {
      state.sessionSettings.status = "pending";
      state.sessionSettings.initializeStatus = "pending";
    }).addCase(initializeSessionSettings.fulfilled, function (state, _ref4) {
      var payload = _ref4.payload;
      state.sessionSettings.status = "done";
      state.sessionSettings.initializeStatus = "done";
      state.sessionSettings.data = payload.sessionSettings;
    }).addCase(initializeSessionSettings.rejected, function (state) {
      state.sessionSettings.status = "error";
      state.sessionSettings.initializeStatus = "error";
    });
  }
});
export default sessionSettingsSlice.reducer;
export var selectSessionSettings = function selectSessionSettings(state) {
  var _state$sessionSetting, _state$sessionSetting2;
  return (_state$sessionSetting = state.sessionSettings) === null || _state$sessionSetting === void 0 ? void 0 : (_state$sessionSetting2 = _state$sessionSetting.sessionSettings) === null || _state$sessionSetting2 === void 0 ? void 0 : _state$sessionSetting2.data;
};
export var selectSessionSettingsStatus = function selectSessionSettingsStatus(state) {
  var _state$sessionSetting3, _state$sessionSetting4;
  return (_state$sessionSetting3 = state.sessionSettings) === null || _state$sessionSetting3 === void 0 ? void 0 : (_state$sessionSetting4 = _state$sessionSetting3.sessionSettings) === null || _state$sessionSetting4 === void 0 ? void 0 : _state$sessionSetting4.status;
};
export var selectSessionSettingsInitializeStatus = function selectSessionSettingsInitializeStatus(state) {
  var _state$sessionSetting5, _state$sessionSetting6;
  return (_state$sessionSetting5 = state.sessionSettings) === null || _state$sessionSetting5 === void 0 ? void 0 : (_state$sessionSetting6 = _state$sessionSetting5.sessionSettings) === null || _state$sessionSetting6 === void 0 ? void 0 : _state$sessionSetting6.initializeStatus;
};